import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { ProcessedGraphMetricData } from 'modules/Telematics/components/TelematicsRightPanel/LiveSummary/types';
import styles from './strip.module.css';
const HOURS_PER_DAY = Array.from({ length: 24 }, (x, i) => {
	return i;
});

interface Props {
	data: ProcessedGraphMetricData;
}
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(() => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: '#f5f5f9',
		color: 'rgba(0, 0, 0, 0.87)',
		maxWidth: 220,
		fontSize: '12px',
		border: '1px solid #dadde9',
	},
}));
export default function Strip({ data }: Props) {
	const icon = data.staticData.icon;
	const backgroundColor = data.staticData.backgroundColor;
	const fillDataList = data.graphData;
	return (
		<div className={styles.metricView}>
			<div className={styles.iconWrapper}>
				<img
					className={styles.icon}
					src={icon.url}
					alt=""
					title={icon.desc}
				/>
			</div>
			<div className={styles.strip}>
				{HOURS_PER_DAY.map((i) => (
					<div className={styles.hourSegment} key={i}></div>
				))}
				{fillDataList.map((fillSegment, index) => {
					return (
						<HtmlTooltip
							key={index}
							title={
								<div>
									{fillSegment.metadata.map((meta, index) => {
										return (
											<Typography
												fontSize="12px"
												key={index}
												color="inherit"
											>
												{meta.label} : {meta.value}
											</Typography>
										);
									})}
								</div>
							}
						>
							<div
								className={styles.filledSegment}
								style={{
									top: fillSegment.offset,
									background: backgroundColor,
									height: fillSegment.height,
								}}
							></div>
						</HtmlTooltip>
					);
				})}
			</div>
		</div>
	);
}
